import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import type { TagProps } from './components/Tag';
import { Tag } from './components/Tag';
import { StyledRoot, StyledContainer, StyledContent, styles } from './ActiveRefinementsBar.styles';
export interface ActiveRefinement {
  label: string;
  value: string;
  onRemove: (e: React.MouseEvent) => void;
}
export interface ActiveRefinementsBarProps {
  tags: ActiveRefinement[];
  onClearAll: (e: React.MouseEvent) => void;
}

export const ClearAll = (props: TagProps) => (
  <Tag
    backgroundColor="white"
    color="mono14"
    _hover={{
      backgroundColor: 'mono1',
      cursor: 'pointer',
      color: 'primary6',
    }}
    _active={{
      backgroundColor: 'mono2',
    }}
    {...props}
  />
);

export const ActiveRefinementsBar: React.FC<ActiveRefinementsBarProps & BoxProps> = ({ tags, onClearAll, ...rest }) => {
  const { t } = useTranslation('catalogRegistry');
  const tRefinementsPanel = t('refinementsPanel');
  if (!tags || tags.length === 0) return null;

  return (
    <StyledRoot {...rest}>
      <StyledContainer>
        <StyledContent
          __css={styles.container}
          style={{ rowGap: '1rem' }}
        >
          {tags.map(({ value, label, onRemove }) => (
            <Tag
              key={value}
              onRemove={onRemove}
            >
              <TextV2 typographyVariant="button1">{label}</TextV2>
            </Tag>
          ))}
          {tags.length > 0 && <ClearAll onClick={onClearAll}>{tRefinementsPanel.clearAll()}</ClearAll>}
        </StyledContent>
      </StyledContainer>
    </StyledRoot>
  );
};
